export { default as InputText } from "./InputText";
